import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Directions.css';

class Directions extends Component {
  render() {
    return (
      <div className="Directions" ref={div => (this.appContainer = div)}>
        <Header />
        <div className="Directions-container">
          <div className="Directions-top"></div>
          <div className="Directions-mid">
            <div className="Directions-header">DIRECTIONS</div>
            <hr />
            <div className="text">
              <div style={{ fontSize: '20px', padding: '0 0 10px 0' }}>
                <b>20 N Raymond Ave Pasadena, CA 91103</b>
              </div>
              <a
                href="https://www.google.com/maps/place/20+N+Raymond+Ave,+Pasadena,+CA+91103/@34.146138,-118.148657,16z/data=!4m5!3m4!1s0x80c2c371c7ce9d83:0x9fb59cb26e3d2469!8m2!3d34.1461383!4d-118.1486574?hl=en-US"
                target="_blank"
                rel="noopener noreferrer"
              >
                {' '}
                [ View Map ]
              </a>
              <br />
              <br />
              <hr />
              <br />
              <div>
                <div className="Directions-title">FROM THE WEST</div>
                <br />
                Take the 134 East toward Pasadena.
                <br />
                Exit on Fair Oaks Ave.
                <br />
                Turn Right onto Fair Oaks Ave.
                <br />
                Turn Left onto Colorado Blvd.
                <br />
                Turn Left onto Raymond Ave.
                <br />
                We’re located on the right, 20 N Raymond Ave.
              </div>
              <br />
              <br />
              <div>
                <div className="Directions-title">FROM THE EAST</div>
                <br />
                Take the 210 West toward Pasadena.
                <br />
                Exit on Fair Oaks Ave.
                <br />
                Turn Left onto Fair Oaks Ave.
                <br />
                Turn Left onto Colorado Blvd.
                <br />
                Turn Left onto Raymond Ave.
                <br />
                We’re located on the right, 20 N Raymond Ave.
              </div>
              <br />
              <br />
              <div className="Directions-title">PARKING</div>
              There are plenty of parking options available near The Bunker. Street metered parking
              available on Raymond and Colorado. 
              
              <p>$1 hourly parking for the first 2 hours available at the parking structure located on Raymond Blvd., south of Colorado, located by the
              Scientology Center. Metro Gold Line Station is also located just a block and half away
              on Arroyo Pkwy and Holly St.</p>
              <br />
              <br />
            </div>
          </div>
          <div className="Directions-bottom"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Directions;
